import { render, staticRenderFns } from "./FeaturedPosts.vue?vue&type=template&id=04477520&scoped=true&"
import script from "./FeaturedPosts.vue?vue&type=script&lang=js&"
export * from "./FeaturedPosts.vue?vue&type=script&lang=js&"
import style0 from "./FeaturedPosts.vue?vue&type=style&index=0&id=04477520&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04477520",
  null
  
)

export default component.exports